"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoUserAuthLevel = void 0;
const utils_1 = require("../../../utils");
var SsoUserAuthLevel;
(function (SsoUserAuthLevel) {
    SsoUserAuthLevel[SsoUserAuthLevel["L0"] = 0] = "L0";
    SsoUserAuthLevel[SsoUserAuthLevel["L1"] = 1] = "L1";
    SsoUserAuthLevel[SsoUserAuthLevel["L2"] = 2] = "L2";
})(SsoUserAuthLevel || (exports.SsoUserAuthLevel = SsoUserAuthLevel = {}));
(function (SsoUserAuthLevel) {
    SsoUserAuthLevel.fn = {
        values: utils_1.EnumUtils.valuesFunc(SsoUserAuthLevel),
        toEnumValue: utils_1.EnumUtils.toEnumValueFunc(SsoUserAuthLevel),
        toEnumKey: utils_1.EnumUtils.toEnumKeyFunc(SsoUserAuthLevel),
    };
})(SsoUserAuthLevel || (exports.SsoUserAuthLevel = SsoUserAuthLevel = {}));
//# sourceMappingURL=SsoUserAuthLevel.js.map